const EduSolData = [
    {
        id: 1,
        title: "Certifications",
        description: "Advance your career and build your confidence with a 3-6 month action-oriented learning experience.",
        img: require("../images/corse.png")
    },
    {
        id: 2,
        title: "Courses",
        description: "Collaborate with a global community in our 5 week online courses and apply new skills to your  work to increase your impact.",
        img: require("../images/courses.png")
    },
    {
        id: 3,
        title: "Track",
        description: "Learn anytime, anywhere. Boost your skills with flexible, short-form online courses designed to fit your life.",
        img: require("../images/track.png")
    }
]

export default EduSolData;